<div class="page-content" *ngIf="!timerService.isForwarding">

     <div><button class="btn-back" title="{{Button.Back_alt | translate}}" (click)="onPreviousClick()" translate>{{Button.Previous}}</button></div>

     <h1 class="page-title" translate>{{'setup_3.page_title'}}</h1>

     <form>
          <div class="padding-botton-5" id="isBornThroughSurrogacy">
               <ng-radio [item-list]="items.yesNoList" id="isBornThroughSurrogacyRadio" 
                    [(ng-model)]="eligibility.isBornThroughSurrogacy" 
                    [(ng-error)]="error_emptyIsBornThroughSurrogacy" 
               >
               <h2 translate>{{'setup_3.questions.surrogacy'}}</h2>
               </ng-radio>
          </div>
          <div>
               <div class="padding-top-5-bottom-10">
                    <accordion header="setup_3.accordion1.more_info_header">
                         <div  innerHTML="{{'setup_3.accordion1.more_info_text1' | translate}}"></div>
                         <div  class="padding-top-1em">
                              {{'setup_3.accordion1.more_info_text2' | translate}}
                         </div>

                         <ul style="list-style-type:circle">
                              <li>
                                   <a href="{{ 'setup_3.accordion1.stat_declare_surrogate_url' | translate }}"
                                        title="{{'setup_3.accordion1.stat_declare_surrogate_title' | translate}}"
                                        target="_blank">{{ "setup_3.accordion1.stat_declare_surrogate" |
                                        translate }}
                                   </a>
                              </li>
                              <li>
                                   <a href="{{ 'setup_3.accordion1.stat_declare_intended_url' | translate }}"
                                        title="{{'setup_3.accordion1.stat_declare_intended_title' | translate}}"
                                        target="_blank">{{ "setup_3.accordion1.stat_declare_intended" |
                                        translate }}
                                   </a>
                              </li>
                         </ul>
                    </accordion>
               </div>
               <div aria-live='polite'>
               <div [hidden]="!(eligibility.isBornThroughSurrogacy === 'Y')">
                    <information outer-style="width:100%">
                         <ng-container *ngTemplateOutlet="additionalDoc_surrogacy"></ng-container>
                    </information>
               </div>
               </div>
          </div>
          <div class="padding-botton-10" id="isCustodyOtherThanParent">
               <ng-radio [item-list]="items.yesNoList" id="isCustodyOtherThanParentRadio" 
                    [(ng-model)]="eligibility.isCustodyOtherThanParent" 
                    [(ng-error)]="error_emptyIsCustodyOtherThanParent" 
                    (change)="onCustodyOtherThanParentChange()"
               >
                    <h2 translate> {{'setup_3.questions.legal_custody'}}</h2>
               </ng-radio>
          </div>
          
          <div class="padding-botton-10" [hidden]="!(eligibility.isCustodyOtherThanParent === 'Y')" id="isOtherCertifyingBirth">
               <ng-radio [item-list]="items.yesNoList" id="isOtherCertifyingBirthRadio" 
                    [(ng-model)]="eligibility.isOtherCertifyingBirth" 
                    [(ng-error)]="error_emptyIsOtherCertifyingBirth" 
               >
                    <h2 translate>{{'setup_3.questions.birth_certify'}}</h2>
               </ng-radio>

               <div class="padding-top-5-bottom-10">
                    <accordion header="setup_3.accordion2.more_info_header">
                         <div translate>
                              {{'setup_3.accordion2.more_info_text1'}}
                         </div>
                         <div class="padding-top-1em"
                              [innerHTML]="'setup_3.accordion2.more_info_text2' | translate">
                         </div>
                    </accordion>
               </div>
               </div>
               <!--CriticalNotice-->
               <div aria-live='assertive'>
               <div [hidden]="eligibility.isOtherCertifyingBirth == null">
                    <notice-box [hidden]="displayCriticalBoxYes() == false" outer-style="width:100%">
                         <div>
                              {{'setup_3.critical_notice_yes' | translate}}
                         </div>
                    </notice-box>

                    <notice-box [hidden]="!(eligibility.isOtherCertifyingBirth == 'N')" outer-style="width:100%">
                         <div>
                              {{'setup_3.critical_notice_no' | translate}}
                         </div>
                    </notice-box>   
               </div>
               </div>
               
               <div [hidden]="!(eligibility.isOtherCertifyingBirth === 'Y') || displayCriticalBoxYes() == true">
                    <ng-container *ngTemplateOutlet="legalCustodian"></ng-container>
               </div>
               
          

      </form>
      <div class="btn-div" style="padding-top: 10px;">

               <div [hidden]="eligibility.isBornThroughSurrogacy=='Y' || eligibility.isCustodyOtherThanParent=='Y'">
                    <button class="btn-next" title="{{Button.Next_alt|translate}}" (click)="onNextClick()" translate>{{Button.Next}}</button>
               </div>

               <div [hidden]="eligibility.isCustodyOtherThanParent!='Y'||eligibility.isOtherCertifyingBirth!='N'">
                    <button class="btn-next" title="{{Button.Cancel_alt|translate}}" (click)="onCancelApplication()" translate>{{Button.Cancel}}</button>
               </div>

               <div [hidden]="eligibility.isCustodyOtherThanParent=='Y'&&eligibility.isOtherCertifyingBirth=='N'||eligibility.isBornThroughSurrogacy!='Y' && eligibility.isCustodyOtherThanParent!='Y'">
                  <div class="button-top">
                        <button class="btn-next2" title="{{Button.Next_alt|translate}}" (click)="onNextClick()" translate>{{Button.Next}}</button>
                  </div>
                  <div class="button-bottom">
                        <button class="btn-cancel2" 
                                title="{{Button.Cancel_alt|translate}}" (click)="onCancelApplication()" translate>{{Button.Cancel}}</button>
                  </div>
               </div>
      </div>
</div>

<!--NG-TEMPLATES-->

<ng-template id="legalCustodyInfo" #legalCustodian>
     <div>
          <h4>{{'setup_3.legal_custodian_info.header' | translate}}</h4>
          
          <div>{{'setup_3.legal_custodian_info.section_text' | translate}}</div>
          
          <div id="otherName">
               <ng-input [(ng-model)]="eligibility.otherFirstName" [ng-disable]="this.eligibility.isOtherSingleName === 'Y'" 
                    size="20" max="50" [(ng-error)]="error_invalidOtherFirstName"
                    alt-text='setup_3.legal_custodian_info.input_fields.first_name_alt_text' id="otherFirstName" margin="/0.5">
                    {{ 'setup_3.legal_custodian_info.input_fields.first_name'}}
               </ng-input>

               <ng-input [(ng-model)]="eligibility.otherLastName" [ng-disable]="this.eligibility.isOtherSingleName === 'Y'" 
                    size="20" max="50" [(ng-error)]="error_invalidOtherLastName" 
                    alt-text='setup_3.legal_custodian_info.input_fields.last_name_alt_text' id="otherLastName" margin="/0.5">
                    {{ 'setup_3.legal_custodian_info.input_fields.last_name'}}
               </ng-input>
          </div>
          <div>
               <ng-checkbox [(ng-model)]="eligibility.isOtherSingleName" (change)="onCheckboxClick()" margin="/0.5">
                    {{'setup_3.legal_custodian_info.checkbox_single_name'}}
               </ng-checkbox> 
               <div class="padding-top-5-bottom-10"  style="padding-left:2.0em">
                    <accordion header="setup_3.legal_custodian_info.accordion3.single_name_header" [(open)]="expandSingleNameAccordion">
                         <span translate>
                              {{'setup_3.legal_custodian_info.accordion3.single_name_text'}}
                         </span>
                    </accordion>
               </div>
               
               <div [hidden]="!(eligibility.isOtherSingleName == 'Y')" id="otherSingleName">
                    <ng-input [(ng-model)]="eligibility.otherSingleName" size="20" max="50" id="otherSingleNameInput"
                         [(ng-error)]="error_invalidOtherSingleName"
                         alt-text='setup_3.legal_custodian_info.input_fields.single_name_alt_text'>
                         {{ 'setup_3.legal_custodian_info.input_fields.single_name'}}
                    </ng-input>
               </div>
               <div>
                    <information outer-style="width:100%">
                         <ng-container *ngTemplateOutlet="additionalDoc_custody; context: {eligibility: eligibility, aboutChild: aboutChild}"></ng-container>
                    </information>
               </div>
          </div>
     </div>
</ng-template>

<ng-template id="additionalDoc_surrogacy" #additionalDoc_surrogacy>
     <div>
          <h3 translate>
               {{'setup_3.additional_documents.header'}}
          </h3>
         
          <div class="padding-top-1em" translate> 
               {{ 'setup_3.additional_documents.text1' }}
          </div>
          <div class="padding-top-1em" translate>
               {{ 'setup_3.additional_documents.text2' }}
          </div>
          <div class="padding-top-1em">
               <strong translate>{{'setup_3.additional_documents.print_title'}}</strong>
          </div>
          <div class="pad-left">  
               <a href="{{ 'setup_3.accordion1.stat_declare_surrogate_url' | translate }}"
                    title="{{'setup_3.accordion1.stat_declare_surrogate_title' | translate}}" target="_blank">{{
                    "setup_3.additional_documents.print_link1" | translate }}
               </a>
          </div>
          <div translate class="pad-left">
               {{'setup_3.additional_documents.print_text'}}
          </div>
          <div class="pad-left">
               <a href="{{ 'setup_3.accordion1.stat_declare_intended_url' | translate }}"
                    title="{{'setup_3.accordion1.stat_declare_intended_title' | translate}}" target="_blank">{{
                    'setup_3.additional_documents.print_link2' | translate }}
               </a>
          </div>

          <div class="padding-top-1em">
               <strong translate>{{'setup_3.additional_documents.sign_title'}}</strong>
          </div>
          <div translate class="pad-left">
               {{ 'setup_3.additional_documents.sign_text' }}
          </div>

          <div class="padding-top-1em">
               <strong translate>{{'setup_3.additional_documents.register_birth_title'}}</strong>
          </div>
          <div translate class="pad-left">
               {{ 'setup_3.additional_documents.register_birth_text' }}
          </div>

          <div class="padding-top-1em">
               <strong translate>{{'setup_3.additional_documents.mail_title'}}</strong>
          </div>
          
          <div [innerHTML]="'setup_3.additional_documents.mail_text' | translate" class="pad-left"></div>

          <div class="padding-top-1em">
               <strong translate>{{'setup_3.additional_documents.note'}}</strong>
          </div>
          <div [innerHTML]="'setup_3.additional_documents.note_text' | translate">
          </div>
     </div>
</ng-template>

<!--Improvement - this can be exported to be a reusable code?-->

<ng-template id="additionalDoc_custody" #additionalDoc_custody let-eligibility="eligibility" let-aboutChild="aboutChild">
     <h3>
          {{'setup_2.additional_doc.header' | translate}}
     </h3>
     <div class="padding-top-1em" translate 
          [hidden]="!(aboutChild.isChildDeceased == 'Y' && eligibility.isOtherCertifyingBirth == 'Y')">
          {{'setup_3.additionalDocsChildDeceased'}}
     </div>
     <div class="padding-top-1em" translate>
          {{ "setup_2.additional_doc.text1" }}
     </div>
     <div class="padding-top-1em" translate>
          {{ "setup_2.additional_doc.text2" }}
     </div>
     <div [innerHTML]="'setup_2.additional_doc.step1_header' | translate" class="padding-top-1em"></div>
     <div class="pad-left">
          {{ "setup_2.additional_doc.step1_text1" | translate }}
          <a routerLink="/{{ orgContactPath }}" href="#" title="{{'setup_2.org_contact_title' | translate}}">
               {{"setup_2.additional_doc.step1_text2" | translate}}</a>
          {{ "setup_2.additional_doc.step1_text3" | translate }}
     </div>

     <div [innerHTML]="'setup_2.additional_doc.step2_header' | translate" class="padding-top-1em"></div>
     <div class="pad-left">
          {{ "setup_2.additional_doc.step2_text1" | translate }}
     </div>

     <div [innerHTML]="'setup_2.additional_doc.step3_header' | translate" class="padding-top-1em"></div>
     <div class="pad-left">
          {{ "setup_2.additional_doc.step3_text1" | translate }}
     </div>

     <div [innerHTML]="'setup_2.additional_doc.step4_header' | translate" class="padding-top-1em"></div>
     <div [innerHTML]="'setup_2.additional_doc.step4_text1' | translate" class="pad-left"></div>

     <div [innerHTML]="'setup_2.header_note' | translate" class="padding-top-1em">
     </div>
     <div [innerHTML]="'setup_2.additional_doc.note_text' | translate">
     </div>
</ng-template>
